import { WHATSAPP_CTA, WHATSAPP_PATH } from "@/lib/masterclass";
import { cn } from "@/lib/utils";

// Bloc « rejoindre le groupe » sur /mc/ty et /mc/hc.
// La destination réelle vit dans /admin (slug `masterclass-whatsapp`) : un lien
// d'invitation WhatsApp expire, il ne peut pas être figé dans le build.
//   prominent : l'action principale de la page (/mc/ty) — vert WhatsApp,
//   pleine largeur, annoncée comme la dernière étape.

export function WhatsappIcon({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={cn("fill-current", className)} aria-hidden>
      <path d="M12 2a10 10 0 0 0-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1 0 12 2Zm5.8 14.1c-.2.7-1.2 1.3-2 1.4-.5.1-1.2.2-3.5-.7-2.9-1.2-4.8-4.2-5-4.4-.1-.2-1.1-1.5-1.1-2.9 0-1.4.7-2 1-2.3.2-.3.6-.4.8-.4h.6c.2 0 .4 0 .7.5l.9 2.2c.1.2.1.4 0 .6l-.4.6-.3.3c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.4 1.5.3.1.4.1.6-.1l.9-1c.2-.2.4-.2.6-.1l2.1 1c.3.1.5.2.5.4.1.1.1.7-.1 1.4Z" />
    </svg>
  );
}

export function WhatsappCta({
  className = "",
  prominent = false,
  onClick,
}: {
  className?: string;
  prominent?: boolean;
  onClick?: () => void;
}) {
  if (prominent) {
    return (
      <div className={cn("rounded-2xl border-2 border-[#25D366]/50 bg-[#25D366]/[0.08] p-5 text-center", className)}>
        <p className="text-xs font-bold uppercase tracking-wide text-[#128C4B]">{WHATSAPP_CTA.step}</p>
        <p className="mt-1.5 text-lg font-extrabold text-ink">{WHATSAPP_CTA.title}</p>
        <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-ink/70">{WHATSAPP_CTA.body}</p>
        <a
          href={WHATSAPP_PATH}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClick}
          className="mt-4 flex w-full cursor-pointer items-center justify-center gap-2.5 rounded-xl bg-[#25D366] px-6 py-4 text-base font-bold text-white shadow-lg shadow-[#25D366]/30 transition hover:bg-[#1FBE5A] active:scale-[0.99]"
        >
          <WhatsappIcon className="h-6 w-6" />
          {WHATSAPP_CTA.cta}
        </a>
      </div>
    );
  }

  return (
    <div className={`rounded-2xl border border-brand/25 bg-brand/[0.07] p-5 ${className}`}>
      <p className="font-semibold text-ink">{WHATSAPP_CTA.title}</p>
      <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-ink/70">
        {WHATSAPP_CTA.body}
      </p>
      <a
        href={WHATSAPP_PATH}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        className="mt-4 inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl bg-brand px-6 py-3 text-sm font-semibold text-cream transition hover:bg-brand-light"
      >
        <WhatsappIcon className="h-4 w-4" />
        {WHATSAPP_CTA.cta}
      </a>
    </div>
  );
}

/** Barre collante en bas d'écran (mobile) : le groupe reste à un pouce. */
export function WhatsappStickyBar({ onClick }: { onClick?: () => void }) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-ink/10 bg-cream/95 px-4 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom,0px))] backdrop-blur sm:hidden">
      <a
        href={WHATSAPP_PATH}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        className="flex w-full items-center justify-center gap-2.5 rounded-xl bg-[#25D366] px-6 py-3.5 text-base font-bold text-white shadow-lg shadow-[#25D366]/30 active:scale-[0.99]"
      >
        <WhatsappIcon className="h-6 w-6" />
        {WHATSAPP_CTA.sticky}
      </a>
    </div>
  );
}
